/* eslint-disable no-else-return */
/* eslint-disable no-undef-init */
import Api from '../../utils/api'
import {
  CORESITE_LOCALSTORAGE,
  SETUPTIME_CORESITE_LOCALSTORAGE
} from '../../utils/constants'

// GET TOKEN
export const getToken = async ({ ...props }) => {
  const { username, apiUrl, clientId, clientSecret, setCookie, cookieName } =
    props

  let token = undefined

  const API_TOKEN_URL = `${apiUrl}/oauth/token`
  const API_TOKEN_GET = {
    url: API_TOKEN_URL,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams({
        grant_type: 'client_credentials',
        client_id: clientId,
        client_secret: clientSecret,
        clear: 'true',
        username
      }).toString()
    }
  }
  const tokenGetRes = await Api.fetch(
    `${API_TOKEN_GET.url}`,
    API_TOKEN_GET.options
  )

  const tokenResponseJson = await tokenGetRes?.json()

  token = tokenResponseJson?.access_token
  const expire = tokenResponseJson?.expires_in

  if (token) {
    setCookie(cookieName, btoa(token), {
      path: '/',
      secure: true,
      maxAge: expire,
      sameSite: 'strict'
    })
    return token
  } else {
    return null
  }
}

// CREATE CART
export const createCart = async ({ ...props }) => {
  const { username, token, apiUrl, language, baseSiteId } = props
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `bearer ${token}`
  }

  const API_CART_URL = `${apiUrl}/v2/${baseSiteId}/users/`
  const API_CART_CREATE = {
    url: API_CART_URL,
    options: {
      method: 'POST',
      headers
    }
  }
  const cartCreateRes = await Api.fetch(
    `${API_CART_CREATE.url}${username}/carts?fields=FULL_WITH_CART&lang=${language}`,
    API_CART_CREATE.options
  )

  return { cartCreateRes }
}

// ADD TO CART
export const addToCart = async ({ ...props }) => {
  const {
    username,
    guid,
    token,
    product,
    quantity,
    apiUrl,
    language,
    baseSiteId
  } = props
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `bearer ${token}`
  }

  const API_CART_URL = `${apiUrl}/v2/${baseSiteId}/users/`
  const API_CART_ADD = {
    url: API_CART_URL,
    options: {
      method: 'POST',
      headers,
      body: JSON.stringify({ product, quantity })
    }
  }

  const cartAddRes = await Api.fetch(
    `${API_CART_ADD.url}${username}/carts/${guid}/entries?fields=FULL_WITH_CART&lang=${language}`,
    API_CART_ADD.options
  )

  return { cartAddRes }
}

export const handleApiResponse = async ({ ...props }) => {
  const {
    response,
    username,
    apiUrl,
    clientId,
    clientSecret,
    setCookie,
    cookieName
  } = props

  if (
    response?.status === Api.responseCodes.RC200 ||
    response?.status === Api.responseCodes.RC201
  ) {
    const responseJson = await response?.json()
    return { responseJson }
  } else if (response?.status === Api.responseCodes.RC401) {
    const token = await getToken({
      username,
      apiUrl,
      clientId,
      clientSecret,
      setCookie,
      cookieName
    })
    return { newToken: token }
  } else if (response?.status === Api.responseCodes.RC400) {
    const errorJson = await response?.json()
    return { errorJson, notFound: true }
  } else {
    const errorJson = await response?.json()
    return { errorJson }
  }
}

// GET CART CODE
export const getCart = async ({ ...props }) => {
  const { username, token, apiUrl, language, baseSiteId } = props

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `bearer ${token}`
  }

  const API_CART_URL = `${apiUrl}/v2/${baseSiteId}/users/`
  const API_CART_GET = {
    url: API_CART_URL,
    options: {
      method: 'GET',
      headers
    }
  }
  const getCartRes = await Api.fetch(
    `${API_CART_GET.url}${username}/carts?fields=FULL&lang=${language}`,
    API_CART_GET.options
  )

  return { getCartRes }
}

// CLEAR CART
export const clearCart: (props: {
  username: string
  token: string
  guid: string
  apiUrl: string
  baseSiteId: string
}) => Promise<{ clearCartRes: Response | null }> = async ({ ...props }) => {
  const { username, token, guid, apiUrl, baseSiteId } = props

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `bearer ${token}`
  }

  const API_CART_URL = `${apiUrl}/v2/${baseSiteId}/users/`
  const API_CART_CLEAR = {
    url: API_CART_URL,
    options: {
      method: 'DELETE',
      headers
    }
  }

  const clearCartRes = await Api.fetch(
    `${API_CART_CLEAR.url}${username}/carts/${guid}`,
    API_CART_CLEAR.options
  )

  localStorage.removeItem(CORESITE_LOCALSTORAGE)
  localStorage.removeItem(SETUPTIME_CORESITE_LOCALSTORAGE)

  return { clearCartRes }
}
